import React, { useEffect, useState } from 'react'

import { Icon, Modal } from 'antd'

import './styles.scss'
import AiMazeGeneration from '../AiMazeGeneration'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

const ChoiceModal = props => {
  const [isAiModalVisible, setIsAiModalVisible] = useState(false)

  const { t } = useTranslation()

  const mazeById = useSelector(state => state.maze.mazeById)

  const { onClose } = props

  useEffect(() => {
    if (mazeById && mazeById.generated_status) {
      setIsAiModalVisible(true)
    }
  }, [mazeById])

  if (isAiModalVisible) {
    return (
      <AiMazeGeneration
        status={mazeById && mazeById.generated_status}
        {...props}
      />
    )
  }

  return (
    <Modal visible footer={false} centered={true} closable={false} width={800}>
      <div className="choice-modal">
        <p> {t('v4:what_kind_maze_create')}</p>

        <div className="choice-modal__items">
          <div className="choice-modal__item" onClick={onClose}>
            <Icon type="user" />
            <h3>{t('v4:manual_metamaze_creation')}</h3>

            <p>{t('v4:manually_maze_customizing_scnario')}</p>
          </div>

          <div
            className="choice-modal__item"
            onClick={() => setIsAiModalVisible(true)}
          >
            <Icon type="robot" />
            <h3>{t('v4:ai_metamaze_generate')}</h3>

            <p>{t('v4:maze_ai_generated')}</p>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default ChoiceModal
